<template>
	<ul
		v-if="pagination.totalPages > 1"
		class="pagination"
	>
		<li
			v-if="pagination.currentPage > 1"
			class="pagination__nav"
		>
			<button
				type="button"
				@click="previousPage"
				class="btn--no-style"
			>
				<span class="sr-only">Previous Page</span>
				<svg svg-inline="" focusable="false" role="presentation" width="14" height="14" viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg"><path d="M3 8l10 8V0L3 8zm0 0" fill="#B1B1B1"/></svg>
			</button>
		</li>
		<li
			v-for="index in pagination.totalPages"
			:key="index"
			@click="selectPage(index)"
			class="pagination__item"
			:class="paginationItemHidden(index)"
		>
			<button
				type="button"
				class="btn--no-style pagination__btn"
				:disabled="index === pagination.currentPage"
			>
				{{ index }}
			</button>
		</li>
		<li
			v-if="pagination.currentPage < pagination.totalPages"
			class="pagination__nav"
		>
			<button
				type="button"
				@click="nextPage"
				class="btn--no-style"
			>
				<span class="sr-only">Next Page</span>
				<svg svg-inline="" focusable="false" role="presentation" width="14" height="14" viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg"><path d="M13 8L3 16V0l10 8zm0 0" fill="#B1B1B1"/></svg>
			</button>
		</li>
	</ul>
</template>

<script>
// Styles
import '@/sass/components/_pagination.scss';

export default {
	props: ['pagination', 'getPaginatedContent'],
	methods: {
		previousPage() {
			if (this.getPaginatedContent) {
				this.pagination.currentPage = this.pagination.currentPage - 1;
				this.getPaginatedContent();
			} else {
				this.$router.push({
					params: {
						pageNumber: this.pagination.currentPage - 1
					}
				});
			}

		},
		nextPage() {
			if (this.getPaginatedContent) {
				this.pagination.currentPage = this.pagination.currentPage + 1;
				this.getPaginatedContent();
			} else {
				this.$router.push({
					params: {
						pageNumber: this.pagination.currentPage + 1
					}
				});
			}
		},
		selectPage(number) {
			if (this.getPaginatedContent) {
				this.pagination.currentPage = number;
				this.getPaginatedContent();
			} else {
				this.$router.push({
					params: {
						pageNumber: number
					}
				});
			}
		},
		paginationItemHidden(index) {
			let allowedValues = [];

			allowedValues.push(this.pagination.currentPage);

			if (this.pagination.currentPage === 1 || this.pagination.currentPage === 2) {
				allowedValues.push(this.pagination.currentPage + 3);
			} else {
				allowedValues.push(this.pagination.currentPage - 2);
			}

			if (this.pagination.currentPage === 1) {
				allowedValues.push(this.pagination.currentPage + 4);
			} else {
				allowedValues.push(this.pagination.currentPage - 1);
			}

			if (this.pagination.currentPage === this.pagination.totalPages || this.pagination.currentPage === this.pagination.totalPages - 1) {
				allowedValues.push(this.pagination.currentPage - 3);
			} else {
				allowedValues.push(this.pagination.currentPage + 2);
			}

			if (this.pagination.currentPage === this.pagination.totalPages) {
				allowedValues.push(this.pagination.currentPage - 4);
			} else {
				allowedValues.push(this.pagination.currentPage + 1);
			}

			if (!allowedValues.includes(index)) {
				return 'hidden';
			}
		}
	}
};
</script>
